import React, { useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { Link } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { firebaseAuth } from "../../../components/firebase/auth";
import { shopAdminApi, type ShopOverviewData } from "./shopAdminApi";
import "./webshopCatalog.css";

const display = (value: number | null) => value === null ? "Ej tillgängligt ännu" : String(value);

export default function WebshopOverview({ previewOnly = false }: { previewOnly?: boolean }) {
  const [user] = useAuthState(firebaseAuth);
  const [data, setData] = useState<ShopOverviewData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [refresh, setRefresh] = useState(0);
  useEffect(() => {
    if (!user || previewOnly) return;
    let live = true;
    setLoading(true); setError("");
    shopAdminApi.overview(user).then((value) => { if (live) setData(value); })
      .catch(() => { if (live) setError("Översikten kunde inte hämtas. Kontrollera API-anslutningen och försök igen."); })
      .finally(() => { if (live) setLoading(false); });
    return () => { live = false; };
  }, [user, previewOnly, refresh]);

  return <div className="DashBoardTabInner FreshDashboardTab WebshopCatalog">
    <div className="FreshTabToolbar"><div><p className="FreshEyebrow">Webshop</p><h2 className="FreshTabTitle">Översikt</h2>
      <p className="FreshTabSummary">Aktuella köer från det skyddade webbshop-API:t.</p></div>
      {!previewOnly && <Button onClick={() => setRefresh((value) => value + 1)} disabled={loading}>Uppdatera</Button>}</div>
    {previewOnly ? <Alert severity="info">Översikten blir tillgänglig när shopAdminApi är driftsatt. Inga antal visas från en lokal förhandsvisning.</Alert> : <>
      {error && <Alert severity="error">{error}</Alert>}
      {loading && <p role="status"><CircularProgress size={20} /> Hämtar översikt…</p>}
      {data && !error && <><p>Uppdaterad {new Date(data.asOf).toLocaleString("sv-SE", { timeZone: "Europe/Stockholm" })}</p>
        <div className="WebshopOverviewGrid">
          <article className="WebshopCatalogProduct"><h3>Kundärenden</h3><strong>{display(data.supportOpen)}</strong><p>Öppna eller under handläggning.</p><Button component={Link} to="/webshop/support">Öppna kö</Button></article>
          <article className="WebshopCatalogProduct"><h3>Ångrade köp</h3><strong>{display(data.withdrawalsOpen)}</strong><p>Mottagna eller under granskning.</p><Button component={Link} to="/webshop/withdrawals">Öppna kö</Button></article>
          <article className="WebshopCatalogProduct"><h3>Spärrat lager</h3><strong>{display(data.heldStock)}</strong><p>Poster med status spärrad eller återkallad.</p><Button component={Link} to="/webshop/inventory">Visa lager</Button></article>
          <article className="WebshopCatalogProduct"><h3>Betalda ordrar att hantera</h3><strong>{display(data.paidOrdersAwaitingAction)}</strong><p>Visas efter att orderflödet är implementerat.</p></article>
          <article className="WebshopCatalogProduct"><h3>Fraktfel</h3><strong>{display(data.bookingFailures)}</strong><p>Visas när fraktflödet via Kustom är anslutet.</p></article>
          <article className="WebshopCatalogProduct"><h3>Återbetalningar att granska</h3><strong>{display(data.refundsRequiringReview)}</strong><p>Visas efter betalningsflödet.</p></article>
        </div></>}
    </>}
  </div>;
}
